module.exports = __webpack_public_path__ + "media/images/icons/icon-check-98327f554a8f3c15680904b55d4d90bf.svg";